export const COMING_SOON_LABEL = "COMING SOON"

/**
 * Gradient COMING SOON badge. Pair with `.coming-soon-host` for hover reveal.
 *
 * @param {"inline-end"|"below"|"above"|"static"} placement
 */
export default function ComingSoonPill({
  className = "",
  placement = "inline-end",
  reveal = true,
  label = COMING_SOON_LABEL,
}) {
  const classes = [
    "coming-soon-pill",
    reveal ? "coming-soon-pill--reveal" : "",
    placement === "inline-end" ? "coming-soon-pill--inline-end" : "",
    placement === "below" ? "coming-soon-pill--below" : "",
    placement === "above" ? "coming-soon-pill--above" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ")

  return <span className={classes}>{label}</span>
}
